import { prefix, ajax } from './common';

export async function getBrands(has_equipment = false) {
  return await ajax({
    url: prefix + '/brands',
    data: {
      has_equipment
    }
  });
}

export async function getBrand(id: number | string) {
  return await ajax({
    url: prefix + '/brands/' + id,
  });
}

export async function getEquipment(id: number | string) {
  return await ajax({
    url: prefix + '/brands/' + id + '/equipment',
  });
}

export async function getManufacturerByBrand(id: number | string) {
  return await ajax({
    url: prefix + '/brands/' + id + '/manufacturer',
  });
}

export async function getEquipmentByBrand(id: number | string) {
  return await ajax({
    url: prefix + '/brands/' + id + '/equipment',
  });
}